import apiClient from '../utils/axiosInterceptor';

export const getProfileDetailsApi = async () => {
    try {
        const response = await apiClient.get('fapp-core-api/api/UserProfile');
        return response.data;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const saveProfileDetailsApi = async (data: any) => {
    try {
        const response = await apiClient.post('fapp-core-api/api/UserProfile', data);
        return response.data;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateProfileDetailsApi = async (data: any) => {
    try {
        const response = await apiClient.put('fapp-core-api/api/UserProfile', data);
        return response.data;
    } catch (error: any) {
        throw new Error(error.message);
    }
};
